import React, { useContext } from "react";

import { ActionItemsContext } from "~/actionItems/newActionItems/ActionItemsContext";
import AssigneeFilter from "~/common/AssigneeFilter";

export default function Assignee() {
	const { filters, viewer } = useContext(ActionItemsContext);
	const user = viewer?.user;
	const { assignedTo, onChangeAssignedTo } = filters;

	return (
		<AssigneeFilter
			values={assignedTo || []}
			setValues={onChangeAssignedTo}
			placeholder="Filter by user"
			isMulti
			hideTeams
			usersToHide={user ? [user.id] : []}
		/>
	);
}
